import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'entity-historyresult',
  templateUrl: './entity-historyresult.component.html',
  styleUrls: ['./entity-historyresult.component.scss']
})
export class EntityResultHistoryComponent implements OnInit {

  entityData = JSON.parse(localStorage.getItem('historyData'))

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    goBackToHistory(this.location);
  }

}
